import React, { useState } from "react";
import { Button, Col, Modal, notification, Row, Spin } from "antd";
import { roleService } from "../../../../services";
import InputField from "../../../input-field";
import { formHelper } from "../../../../helpers";
import '../../modals.css';
import i18n from '../../../../i18n';

export default function ModalCreateRole({ isShow, onCloseModal }) {

    const [loadingContentModal, setLoadingContentModal] = useState(false);
    const [roleName, setRoleName] = useState('');
    const [roleDesc, setRoleDesc] = useState('');

    const [fieldsErrors, setFieldsErrors] = useState(null);

    let bigButtonStyle = { width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px', color: "white", borderColor: "transparent" };

    const getFieldErrors = (nameField) => formHelper.getFieldErrors(nameField, fieldsErrors);

    const onClickCreate = () => {
        setLoadingContentModal(true);

        roleService.create(roleName, roleDesc)
            .then((response) => {
                setLoadingContentModal(false);

                if (response.status === 'success') {

                    notification.success({
                        message: i18n.t('components.notification.titles.roleServiceCreate'),
                        description: response.message,
                    });

                    onCloseModal();

                } else if (response.status === 'error') {

                    setFieldsErrors(response.errors);
                }
            })
            .catch((error) => {
                setLoadingContentModal(false);
                notification.error({
                    message: i18n.t('components.notification.titles.roleServiceCreate'),
                    description: error,
                });
            })
    };

    return (
        <Modal
            title={<span>{i18n.t('modals.modalCreateRole.title')}</span>}
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            align={null}
            visible={isShow}
            onCancel={onCloseModal}
            footer={[
                <Button htmlType="submit" key="submit" type="primary" onClick={onClickCreate} style={bigButtonStyle}>{i18n.t('main.buttons.create')}</Button>,
            ]}
        >
            <Spin spinning={loadingContentModal} tip={i18n.t('main.loadText.loading')}>
                <Row gutter={[16, 24]} >
                    <Col span={24} >
                        <InputField name="title" label={i18n.t('modals.modalCreateRole.fields.title.title')} value={roleDesc} setValue={setRoleDesc}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                    <Col span={24} >
                        <InputField name="name" label={i18n.t('modals.modalCreateRole.fields.name.title')} value={roleName} setValue={setRoleName}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                </Row>
            </Spin>
        </Modal>
    );
}
